export default "__VITE_ASSET__b78f5a60__"